import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { CreateButton, Drawer } from '~/components';
import { CreateForm } from '~/components/ra';
import LegalConsentForm from './LegalConsentForm';
import { Solution } from '~/types';
import useCrudGetManyReference from '~/hooks/useCrudGetManyReference';

import { LegalConsentFilters } from '~/types/LegalConsent';

interface LegalConsentCreateProps {
  permissions: string[];
  solutionRecord: Solution;
  filters?: LegalConsentFilters;
}

const LegalConsentCreate = (props: LegalConsentCreateProps) => {
  const { permissions, solutionRecord, filters } = props;
  const resource = 'legalConsents';
  const target = 'solutions';
  const targetId = solutionRecord?.id;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const crudGetManyReference = useCrudGetManyReference(resource, target, targetId, {
    sort: { field: 'created', order: 'DESC' },
    filters: filters,
  });
  const translate = useTranslate();
  const t = (key: string): string => translate(`resources.legalConsents.fields.${key}`);

  if (!permissions?.includes('solution.legalConsent.create')) return null;
  return (
    <>
      <CreateButton onClick={handleOpen} variant='add' label={t('addNew')} />
      <Drawer heading={t('addNew')} open={open} onClose={handleClose}>
        <CreateForm
          resource={target}
          id={solutionRecord?.id}
          subresource={resource}
          closeParent={handleClose}
          updateAfterSubmit={() => targetId && crudGetManyReference()}
          parseRecordBeforeSubmit={(data: any) => ({ ...data, solutionId: solutionRecord?.id })}
        >
          <LegalConsentForm />
        </CreateForm>
      </Drawer>
    </>
  );
};

export default LegalConsentCreate;
